module.exports = __webpack_public_path__ + "static/0073-204296cfa93da98d90b018e5ce5ab71a.png";